import { EmailField, StringField } from '@src/permitField/PermitFields';

export class ClientUserNameField extends StringField {
  public static fieldName = 'name' as const;
}

export class ClientUserEmailField extends EmailField {
  public static fieldName = 'email' as const;
}

export class ClientUserPhoneField extends StringField {
  public static fieldName = 'phone' as const;
}
